import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Re-runs duplicate detection when the employees collection changes scenario
 * context.
 */
export const loadForCurrentEntityOnContextChange = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    plugin.collection.feature.actions.changeContext
      .observe()
      .pipe(
        rxjs.map(() =>
          feature.actions.loadForCurrentEntity.request
            .from(
              '(effect) load duplicate employees for current entity on context change',
            )
            .create(),
        ),
      ),
)
